import { useRef, useState } from 'react';

/*
 * An on-screen joystick for steering the trace cursor with a thumb. Reports a
 * direction vector (length 0..1) while held; a small dead zone stops a resting
 * thumb from drifting the cursor.
 */
export const DEAD_ZONE = 0.12;

export default function VirtualJoystick({ onChange, size = 96, label }) {
  const baseRef = useRef(null);
  const active = useRef(null);
  const [knob, setKnob] = useState([0, 0]);

  const read = (event) => {
    const rect = baseRef.current.getBoundingClientRect();
    const half = size / 2;
    let x = (event.clientX - (rect.left + rect.width / 2)) / half;
    let y = (event.clientY - (rect.top + rect.height / 2)) / half;
    const length = Math.hypot(x, y);
    if (length > 1) { x /= length; y /= length; }
    if (Math.hypot(x, y) < DEAD_ZONE) { x = 0; y = 0; }
    return [x, y];
  };

  const down = (event) => {
    event.preventDefault();
    active.current = event.pointerId ?? 1;
    if (event.currentTarget.setPointerCapture && event.pointerId !== undefined) {
      try { event.currentTarget.setPointerCapture(event.pointerId); } catch { /* not capturable */ }
    }
    const v = read(event);
    setKnob(v);
    onChange(v, false);
  };
  const move = (event) => {
    if (active.current === null) return;
    const v = read(event);
    setKnob(v);
    onChange(v, false);
  };
  const up = () => {
    if (active.current === null) return;
    active.current = null;
    setKnob([0, 0]);
    onChange([0, 0], true);
  };

  return (
    <div ref={baseRef} data-testid="annotation-joystick" role="application" aria-label={label} title={label}
         onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up}
         style={{ width: size, height: size, borderRadius: '50%', position: 'relative', touchAction: 'none',
                  background: 'rgba(17,24,39,0.35)', border: '2px solid rgba(255,255,255,0.75)' }}>
      <div style={{ position: 'absolute', left: '50%', top: '50%', width: size * 0.42, height: size * 0.42,
                    borderRadius: '50%', background: 'rgba(255,255,255,0.9)', pointerEvents: 'none',
                    transform: `translate(calc(-50% + ${knob[0] * size * 0.3}px), calc(-50% + ${knob[1] * size * 0.3}px))` }} />
    </div>
  );
}
